import Hidden from '@mui/material/Hidden';
import { styled } from '@mui/material/styles';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { useDispatch, useSelector } from 'react-redux';
import { navbarCloseMobile, selectFuseNavbar } from 'app/store/fuse/navbarSlice';
import { selectFuseCurrentLayoutConfig } from 'app/store/fuse/settingsSlice';
import NavbarStyle1Content from './NavbarStyle1Content';
import { Alert, Avatar, Button, IconButton, Snackbar, SnackbarContent } from '@mui/material';
import { useState } from 'react';
import { GridCloseIcon } from '@mui/x-data-grid';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import mesaggeSound from "../../../../../../sounds/play.mp3";
import { useEffect } from 'react';
import { selectUser } from 'app/store/userSlice';



const navbarWidth = 280;

const StyledNavBar = styled('div')(({ theme, open, position }) => ({
  minWidth: navbarWidth,
  width: navbarWidth,
  maxWidth: navbarWidth,
  ...(!open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(position === 'left' && {
      marginLeft: `-${navbarWidth}px`,
    }),
    ...(position === 'right' && {
      marginRight: `-${navbarWidth}px`,
    }),
  }),
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const StyledNavBarMobile = styled(SwipeableDrawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    minWidth: navbarWidth,
    width: navbarWidth,
    maxWidth: navbarWidth,
  },
}));

function NavbarStyle1(props) {
  const dispatch = useDispatch();
  const user = useSelector(selectUser)
  const config = useSelector(selectFuseCurrentLayoutConfig);
  const navbar = useSelector(selectFuseNavbar);
  const { t } = useTranslation('translate-language');
  const [open, setOpen] = useState(false);
  const sound = new Audio(mesaggeSound)
  const [data, setData] = useState([]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClick();
    }, 6000);

    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    axios.get(`/v1/notification/get-all/${user.user_id}`)
      .then(response => {
        if(response.data.length>0){
        setOpen(true)
        sound.play()
        setData(response.data)
      }       
      })
      .catch(error => {
        console.error('Error making request:', error);
      });
      setTimeout(handleClick, 6000);
  };
  
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const action = (
    <>
      <Button color="secondary" size="small" onClick={handleClose}>
        UNDO
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <GridCloseIcon fontSize="small" />
      </IconButton>
    </>
  );




  return (
    <>
      <Hidden lgDown>
        <StyledNavBar
          className="flex-col flex-auto sticky top-0 overflow-hidden h-screen shrink-0 z-20 shadow-5"
          open={navbar.open}
          position={config.navbar.position}
        >
          <NavbarStyle1Content />
        </StyledNavBar>
      </Hidden>

      <Hidden lgUp>
        <StyledNavBarMobile
          classes={{
            paper: 'flex-col flex-auto h-full',
          }}
          anchor={config.navbar.position}
          variant="temporary"
          open={navbar.mobileOpen}
        
          onClose={() => dispatch(navbarCloseMobile())}
          onOpen={() => { }}
          disableSwipeToOpen
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <NavbarStyle1Content />
        </StyledNavBarMobile>
      </Hidden>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        action={action}
        style={{
          width: "100%"
        }}
      >
        <SnackbarContent
          style={{
            backgroundColor: "#2a3042",
            color: "white"
          }}
          message={
            <div>
              < div className='flex justify-between items-start w-full gap-8'>
                <div>
                  {data.map((row) => (
                    <div className='flex items-end gap-8 mb-16'>
                      <div className='text-center'>
                        <Avatar
                          className='m-auto mb-8'
                          alt="Avatar"
                          src="/avatar.jpg" // Replace with the URL of your avatar image
                          sx={{ width: 32, height: 32, }}
                        />
                        <p className='text-13 w-[100px] text-center !text-white'>Рабочее место: {row.doctor_name}</p>
                      </div>

                      <div className='text-13 '>
                        <p className='text-16 font-400'>Запись в журнал</p>
                        <p > {row.product}</p>
                        <p className='mt-8'>Клиент:  {row.client_name} </p>
                        <p ><span >Время: </span>
                          {t(new Date(row.created_date).toLocaleDateString('en-EN', { day: "numeric" }))} {t(new Date(row.created_date).toLocaleDateString('en-EN', { month: "long" }))}, {t(new Date(row.created_date).toLocaleDateString('en-EN', { year: "numeric" }))} {new Date(row.created_date).toLocaleString('en-EN', { hour: 'numeric', minute: 'numeric', hour12: false })}
                        </p>
                      </div>
                    </div>
                  ))}



                </div>

                <div>
                  <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={handleClose}
                    sx={{ marginRight: 'auto' }}
                  >
                    <GridCloseIcon fontSize="small" />
                  </IconButton>
                </div>
              </div>
              <Link to="/home" onClick={handleClose} type='text' className='text-blue-400  text-end block mr-16'>Просмотреть запись → </Link>
            </div>
          }
        />
      </Snackbar>



    </>
  );
}

export default NavbarStyle1;
